import React, { Component } from 'react';
import { getWindowWidthSize } from '../../helpers/misc-javascript-helpers.js';

class PaypalBanner extends Component {
  constructor(props) {
    super(props);
    this.addPaypalBanner = this._addPaypalBanner.bind(this);
    this.activeBanner;
    this.script;
  }

  componentDidMount() {
    this.makePayPalBanner();
    //Calling the method that injects the banner 2 times but each has a different size placement argument
  }

  _addPaypalBanner(placementtype) {
    this.script = document.createElement('script');
    this.script.type = 'text/javascript';
    this.script.setAttribute('data-pp-payerid', "SGK3682G459CA");
    this.script.setAttribute('data-pp-placementtype', placementtype);
    this.script.setAttribute('data-pp-style', "BLUWHTYCSS");
    this.script.async = true; //so we don't have to wait for paypal to display cart
    this.script.innerHTML =
      '                (function (d, t) {\n' +
      '                        "use strict";\n' +
      '                        var s = d.getElementsByTagName(t)[0], n = d.createElement(t);\n' +
      '                        n.src = "//www.paypalobjects.com/upstream/bizcomponents/js/merchant.js";\n' +
      '                        s.parentNode.insertBefore(n, s);\n' +
      '                }(document, "script"));\n';
    this.instance.appendChild(this.script);
  }

  /**
   * @method makePayPalBanner - Determines which PayPal banner to load based on screen size or device width.
   * This helps avoid event listener or DOM complications since dynamic code from PayPal usually has duplication 
   * restrictions.
   */
  makePayPalBanner() {
    var currentWindowSize = getWindowWidthSize();
    if (currentWindowSize > 991) {
      this.addPaypalBanner("180x150");
    } else {
      this.addPaypalBanner("728x90");
    }
    this.activeBanner = true;
  }

  render() {
    return (
      <div id="payPalContainer">
        <div className="paypal-script__block" ref={el => (this.instance = el)} />
        <div className="paypal-banner__text__caption" style={{ fontSize: '.8em' }} aria-label={'PayPal banner disclaimer'}>Content in the banner above is controlled solely by PayPal.</div>
      </div>
    );
  }
}

export default PaypalBanner;

